<template>
  <div class="rc-l-public rc-l-public--content">
    <div class="rc-l-public--title">
      <div class="container">
        <h1 class="mx-auto">{{ $t("statics.content.title") }}</h1>
      </div>
    </div>
    <!-- section 1 : Text intro -->
    <div class="rc-section">
      <div class="container text-center">
        <div class="row justify-content-center">
          <div class="col-lg-10 rc-col-text">
            <p
              class="mx-auto rc-intro--xl"
              v-html="$t('statics.content.section1.text')"
            ></p>
          </div>
        </div>
      </div>
    </div>

    <!-- section 2 : A personalized profile that generates recommendations just for you-->
    <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-xl-5">
            <img
              src="/src/assets/img/illustrations/horse_working_combined.svg"
              class="rc-horse-working-combined"
              alt=""
            />
          </div>
          <div class="co-md-6 rc-col-text rc-col-max-width">
            <h2 v-html="$t('statics.content.section2.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.content.section2.text.1')"
            ></p>
            <p
              class="rc-intro"
              v-html="$t('statics.content.section2.text.2')"
            ></p>
          </div>
        </div>
      </div>
    </section>
    <!-- section 3 : Use our themes and filters to find exactly what you’re looking for-->
    <section class="rc-bg-wave-yellow-1">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-xl-6 rc-col-text rc-col-max-width">
            <h2 v-html="$t('statics.content.section3.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('statics.content.section3.text.1')"
            ></p>
            <p
              class="rc-intro"
              v-html="$t('statics.content.section3.text.2')"
            ></p>
            <h3 v-html="$t('statics.content.section3.list.title')"></h3>
            <ul class="rc-list-bullet">
              <li v-html="$t('statics.content.section3.list.1')"></li>
              <li v-html="$t('statics.content.section3.list.2')"></li>
              <li v-html="$t('statics.content.section3.list.3')"></li>
              <li v-html="$t('statics.content.section3.list.4')"></li>
              <li v-html="$t('statics.content.section3.list.5')"></li>
              <li v-html="$t('statics.content.section3.list.6')"></li>
            </ul>
            <p
              class="rc-intro"
              v-html="$t('statics.content.section3.text.3')"
            ></p>
          </div>
          <div class="col-lg-5 col-xl-4">
            <img
              src="/src/assets/img/illustrations/alligator_archery_combined.svg"
              class="rc-alligator-archery-combined"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <!-- section 4 : Serving librarians -->
    <section class="rc-section-last">
      <div class="container text-center">
        <div class="row justify-content-center">
          <div class="col-lg-10 rc-col-text">
            <h2 v-html="$t('statics.content.section4.title')"></h2>
            <p
              class="mx-auto rc-intro"
              v-html="$t('statics.content.section4.text.1')"
            ></p>
            <p
              class="mx-auto rc-intro"
              v-html="$t('statics.content.section4.text.2')"
            ></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { navMixin } from "#/routes/mixins";
export default {
  name: "RcSiteContentLanding",
  mixins: [navMixin]
};
</script>

<style lang="scss"></style>
